import styled from 'styled-components'
import {
  CONTAINER_WIDTH,
  CONTENT_PADDING_DESKTOP,
  CONTENT_PADDING_LAPTOP, CONTENT_PADDING_MOBILE,
  CONTENT_PADDING_TABLET, HEADER_FONT_SIZE_DESKTOP, HEADER_FONT_SIZE_MOBILE, HEADER_FONT_SIZE_TABLET,
  THEME, TITLE_FONT_SIZE_DESKTOP, TITLE_FONT_SIZE_MOBILE, TITLE_FONT_SIZE_TABLET,
} from '../../constant'
import IMAGES from '../../images'
import { Button } from 'antd'
import Title from 'antd/es/typography/Title'

export const Container = styled.div`
  position: relative;
  display: ${props => props.display || 'block'};
  flex-direction: ${props => props.flexDirection || 'row'};
  justify-content: ${props => props.justifyContent || 'start'};
  align-items: ${props => props.alignItems || 'start'};
  flex-wrap: ${props => props.flexWrap || 'nowrap'};

  gap: ${props => props.gap};
  margin: 0 auto;
  width: ${CONTAINER_WIDTH.XXL}%;
  height: ${props => props.height ? props.height : 'auto'};
  background-color: ${props => props.backgroundColor || 'transparent'};
  background-image: url(${props => props.backgroundImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  @media only screen and (min-width: 1600px) {
    width: ${CONTAINER_WIDTH.XXL}%;
  }
  @media only screen and (max-width: 1599px) {
    width: ${CONTAINER_WIDTH.XL}%;
  }
  @media only screen and (max-width: 1199px) {
    width: ${CONTAINER_WIDTH.LG}%;
  }
  @media only screen and (max-width: 991px) {
    width: ${CONTAINER_WIDTH.MD}%;
  }
  @media only screen and (max-width: 767px) {
    width: ${CONTAINER_WIDTH.SM}%;
  }
  @media only screen and (max-width: 576px) {
    width: ${CONTAINER_WIDTH.XS}%;
  }
`

export const PaginationLabel = styled.span`
  color: #767676;
  @media only screen and (max-width: 768px) {
    margin-bottom: 16px;
  }
`
export const RowSpaceBetweenDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: ${props => props.flexWrap || 'wrap'};
  margin: ${props => props.margin || 0};
  padding: ${props => props.padding || '0 16px'};
  @media only screen and (max-width: 767px) {
    justify-content: center;
    flex-direction: column;
  }
`
export const ColorText = styled.span`
  color: ${props => props.color || '#333'};
  font-weight: ${props => props.fontWeight || 'normal'};
  padding: ${props => props.padding || '0'};
  margin: ${props => props.margin || '0'};
  font-size: ${props => props.fontSize};
  cursor: ${props => props.cursor || 'auto'};
  white-space: ${props => props.whiteSpace ? props.whiteSpace : 'pre-wrap'};
`
export const CircleBackground = styled.div`
  display: ${props => props.display ? props.display : 'block'};
  justify-content: ${props => props.justifyContent ? props.justifyContent : 'start'};
  align-items: ${props => props.alignItems ? props.alignItems : 'start'};
  position: relative;
  background: url(${IMAGES.CIRCLE_BG}) center center no-repeat;
  background-size: cover;
  height: ${props => props.height ? props.height : 'auto'};
  padding: ${props => props.padding ? props.padding : '0'};
  width: 100%;
`
export const ButtonGradientWrapper = styled.div`
    text-align: center;
    width: 100%;
    margin: ${props => props.margin ? props.margin : '0'};
`
export const ButtonGradient = styled(Button)`
  background: linear-gradient(90deg, #214081 0%, #23B04E 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 22px;
  height: ${props => props.height ? props.height : '64px'};
  padding: 4px 32px;
  border-radius: 32px;
  text-transform: uppercase;
  margin: 0 auto;
  @media only screen and (max-width: 767px) {
    font-size: 16px;
    padding: 4px 24px;
    margin-bottom: 16px;
  }

  &:hover {
    background: linear-gradient(90deg, #214081 0%, #23B04E 100%) !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    font-size: 22px !important;
    height: ${props => props.height ? props.height : '64px'} !important;
    border-radius: 32px !important;
    @media only screen and (max-width: 767px) {
      font-size: 16px !important;
      padding: 4px 24px !important;
      margin-bottom: 16px !important;
    }
  }
`
export const CenterBoxShadow = styled.div`
  background-color: ${THEME.PRIMARY_COLOR};
  box-shadow: 5px 3px 9.4px 0px #00000059;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  cursor: pointer;
  gap: 4px;

  @media only screen and (max-width: 1200px) {
    width: 280px;
  }
  @media only screen and (max-width: 768px) {
    width: 256px;
  }
`
export const CenterBoxText = styled.div`
  text-align: center;
  color: ${THEME.PRIMARY_COLOR};
  font-weight: 700;
  font-size: 28px;
  margin-top: 32px;
  @media only screen and (max-width: 1199px) {
    font-size: 20px;
    margin-top: 16px;
    margin-bottom: 16px;
    width: 280px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 18px;
    width: 256px;
  }
`
export const AroundBoxShadow = styled.div`
    box-shadow: 4px -2px 9.4px 0px #00000040;
    padding: 24px;
    background: #F3F4FA;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    img {
        width: 100px;
        height: 100px;
    }
    @media only screen and (max-width: 1200px) {
    }
   
    @media only screen and (max-width: 768px) {
        width: auto;
        margin: 16px;
        justify-content: start;
        align-items: center;
        
        img {
            height: 48px;
            width: 48px;
        }
    }
`
export const AroundBoxText = styled.div`
    text-align: center;
    color: #575757;
    font-weight: 700;
    font-size: 14px;
    margin-top: 16px;
    width: 280px;
    @media only screen and (max-width: 1199px) {
        font-size: 14px;
        margin-top: 16px;
        margin-bottom: 16px;
        width: 280px;
    }
    @media only screen and (max-width: 768px) {
        display: none;
    }
`
export const AroundBoxTextMobile = styled.div`
    text-align: left;
    color: #575757;
    font-weight: 700;
    font-size: 14px;
    display: none;
    margin: 4px 0 0 8px;

    @media only screen and (max-width: 768px) {
        font-size: 14px;
        display: block;
    }
`
export const ContentWrapper = styled.div`
  display: ${props => props.display || 'block'};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  gap: ${props => props.gap};
  padding: ${props => props.noPadding ? '0' : props.padding || CONTENT_PADDING_DESKTOP};
  height: 100%;
  width: 100%;
  @media only screen and (max-width: 1600px) {
    padding: ${props => props.noPadding ? '0' : props.padding || CONTENT_PADDING_LAPTOP};
  }
  @media only screen and (max-width: 1440px) {
    padding: ${props => props.noPadding ? '0' : props.padding || CONTENT_PADDING_LAPTOP};
  }
  @media only screen and (max-width: 992px) {
    padding: ${props => props.noPadding ? '0' : props.padding || CONTENT_PADDING_TABLET};
    height: auto;
  }
  @media only screen and (max-width: 768px) {
    padding: ${props => props.noPadding ? '0' : props.padding || CONTENT_PADDING_TABLET};
    height: auto;
  }
  @media only screen and (max-width: 480px) {
    padding: ${props => props.noPadding ? '0' : props.padding || CONTENT_PADDING_MOBILE};
  }
`
export const IntroTitle = styled.span`
  background: linear-gradient(270deg, #00B74F -22.41%, #1D4289 108.33%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  font-size: ${HEADER_FONT_SIZE_DESKTOP};
  text-align: justify;
  margin-top: 60px;
  margin-bottom: 8px;
  word-break: break-word;
  white-space: pre-wrap;
  line-height: 130%;
  @media only screen and (max-width: 1440px) {
    font-size: 30px;
  }
  @media only screen and (max-width: 1024px) {
    font-size: 28px;
  }
  @media only screen and (max-width: 768px) {
    font-size: ${HEADER_FONT_SIZE_TABLET};
    display: block;
    text-align: left;
    margin: 0;
  }
  @media only screen and (max-width: 480px) {
    font-size: ${HEADER_FONT_SIZE_MOBILE};
    display: block;
    text-align: center;
    margin: 0;
    padding: 0;
  }
`
export const IntroDescription = styled.div`
  font-weight: 700;
  font-size: ${TITLE_FONT_SIZE_DESKTOP};
  color: rgb(63, 63, 63);
  padding: ${props => props.padding || '4px 0 16px 0'};
  margin: ${props => props.margin || '0'};
  line-height: 150%;
  @media only screen and (max-width: 1600px) {

  }
  @media only screen and (max-width: 1440px) {
    font-size: 23px;
  }
  @media only screen and (max-width: 1024px) {
    padding: ${props => props.padding || '8px 0'};
  }
  @media only screen and (max-width: 768px) {
    font-size: ${TITLE_FONT_SIZE_TABLET};
    display: block;
    text-align: left;
  }
  @media only screen and (max-width: 480px) {
    font-size: ${TITLE_FONT_SIZE_MOBILE};
    padding: ${props => props.padding || '8px'};
    display: block;
    text-align: center;
  }
`
export const IconFooter = styled.img`
  height: 96px;
  @media only screen and (max-width: 768px) {
    height: 80px;
  }
`
export const LogoWrapper = styled.div`
  margin-bottom: 11px;

  img {
    height: 28px;
  }

  @media only screen and (max-width: 1440px) {
    img {
      height: 28px;
    }
  }
  @media only screen and (max-width: 1024px) {
    img {
      height: 24px;
    }
  }
  @media only screen and (max-width: 768px) {
    img {
      height: 24px;
    }
  }
  @media only screen and (max-width: 480px) {
    text-align: center;
    img {
      height: 24px;
    }
  }
`
export const ButtonLogin = styled(Button)`
  background: ${props => props.default ? '#fff' : 'linear-gradient(90deg, #214081 0%, #23B04E 100%)'};
  color: ${props => props.default ? THEME.PRIMARY_COLOR : '#fff'};
  font-weight: 700;
  font-size: 14px;
  border-radius: 32px;
  height: 44px;

  padding: 4px 16px;
  text-transform: uppercase;
  margin: 8px auto 0 auto;
  @media only screen and (max-width: 767px) {
    font-size: 16px;
    padding: 4px 24px;
    margin-bottom: 16px;
  }

  &:hover {
    background: ${props => props.default ? '#fff' : 'linear-gradient(90deg, #214081 0%, #23B04E 100%)'} !important;
    color: ${props => props.default ? THEME.PRIMARY_COLOR : '#fff'} !important;
    font-weight: 700;
    font-size: 14px;
    border-radius: 32px !important;
    height: 44px !important;

    @media only screen and (max-width: 767px) {
      font-size: 16px !important;
      padding: 4px 24px !important;
      margin-bottom: 16px !important;
    }
  }
`


export const CustomTitle = styled(Title)`
  && {
    color: white;
  }
`

export const CourseContentWrapper = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`
export const AuthLoginTitle = styled.h1`
  color: #ffffff;
  text-align: center;
  margin: 16px 0;
  font-size: 20px;
  font-weight: 500;
`
export const AuthLoginSubTitle = styled.h2`
  color: #ffffff;
  text-align: center;
  margin: 16px 0;
  font-size: 16px;
  font-weight: 500;
`
export const LogoLogin = styled.img`
`
export const StepFinalText = styled.div`
  font-size: 18px;
  font-weight: 500;
  padding-bottom: 32px;
  text-align: ${props => props.textAlign ? props.textAlign : 'center'};
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`
export const SuccessImage = styled.div`
  text-align: center;
  margin-bottom: 24px;
`
export const CenterDiv = styled.div`
  text-align: center;
`
export const FinalStepContent = styled.div`
  font-size: 16px;
  margin-bottom: 32px;
  line-height: 24px;
  text-align: ${props => props.textAlign || 'justify'};
`
export const FinalStepTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  line-height: 24px;
  text-align: ${props => props.textAlign || 'justify'};
`
export const TextGradientWrapper = styled.div`
    text-align: center;
    padding: 16px 0;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    line-height: 25px;
    overflow: visible;
`
export const TextGradient = styled.span`
    background: linear-gradient(270deg, #00B74F -22.41%, #1D4289 108.33%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 24px;
    font-weight: 700;
    line-height: 25px;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    overflow: visible;
    @media only screen and (max-width: 768px) {
        font-size: 16px;
    }
`
export const CampaignContentText = styled.div`
    text-align: justify;
    font-size: 16px;
    margin-top: 16px;
    padding-right: 16px;
    @media only screen and (max-width: 768px) {
        padding-right: 0;
    }
`